import React, { useEffect, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg15 from "../../../../../../assets/svg/svg15.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg13 from "../../../../../../assets/svg/svg13.svg";
import CardLoading from "../../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import DataSchemeAdd from "./DataSchemeAdd";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import {
  fetchData,
  fetchSchemeBlocks,
} from "../../../../../../features/fetch/fetchSlice";
import moment from "moment/moment";
import { formatText } from "../../../../../../utils";
import toast from "react-hot-toast";
import { save } from "../../../../../../features/save/saveSlice";

function DataSchemeTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "prod/get_production";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  const { refetchKey } = useSelector((state) => state.global);
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [openSubmit, setOpenSubmit] = useState(false);
  const handleOpenSubmit = () => {
    setOpenSubmit(true);
  };
  const handleCloseSubmit = () => {
    setOpenSubmit(false);
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        proType: e.target.value == "" ? null : e.target.value,
        proSchId: activeObjSchemes?.schId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const handleSend = () => {
    handleOpenSubmit();
  };

  const handleSubmit = async() => {
    const res = await dispatch(
      save({
        proId:prodd?.proId,
        url: "prod/notify_farmers",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message); 
      await setOpenSubmit(false)
      await fetchDataSchemeData()
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleDelete = () => {};
  const settingItems = [
    {
      key: "1",
      label: (
        <div   onClick={handleEdit}>
          <Link
          
            className="flex actions-text gap-x-[.75rem] my-2 "
          >
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div     onClick={handleOpenDelete}>
          <Link
        
            className="flex actions-text gap-x-[.75rem] my-2 "
          >
            <img src={svg13} alt="svg13" /> Delete
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div>
          <Link
            onClick={handleSend}
            className="flex actions-text gap-x-[.75rem] my-2 "
          >
            <img src={svg15} alt="svg15" /> Send
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "proType",
      render: (item) => {
        return <div>{formatText(item)}</div>;
      },
      sorter: (a, b) => a.proType.localeCompare(b.proType),
    },
    {
      title: "Start Period",
      dataIndex: "proStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.proStartDate).valueOf() - moment(b.proStartDate).valueOf(),
    },
    {
      title: "End Period",
      dataIndex: "proEndDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.proEndDate).valueOf() - moment(b.proEndDate).valueOf(),
    },
    {
      title: "Blocks",
      dataIndex: "proBlockName",
      sorter: (a, b) => a.proBlockName.localeCompare(b.proBlockName),
    },
    {
      title: "Responses",
      dataIndex: "usrMobileNumber",
      sorter: (a, b) => a.usrMobileNumber.localeCompare(b.usrMobileNumber),
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchDataSchemeData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        proSchId: activeObjSchemes?.schId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 3) {
      fetchDataSchemeData();
      dispatch(fetchSchemeBlocks({ blocSchId: activeObjSchemes?.schId }));
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className=" w-full">
      <div className="flex items-center justify-between  ">
        <div className="form-add-h">List of Data Collection Requests</div>
        <div className="w-[200px]">
          <button onClick={() => handleAdd()} className="cstm-btn-2">
            <span className="ml-1">Create Data Request</span>
          </button>
        </div>
      </div>

      <div className="mt-[1.25rem">
        <Divider />
      </div>
      <div className="lg:w-[29.1875rem] w-auto mt-[1.25rem]">
        <Search
          searchInput={searchInput}
          handleSearch={handleSearch}
          text={"Search data request..."}
        />
      </div>

      <Table
        rowSelection={false}
        className="mt-[1.31rem] w-full"
        scroll={{
          x: 1200,
        }}
        rowKey={(record) => record?.proId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchDataSchemeData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />

      <DataSchemeAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchDataSchemeData}
        prodd={prodd}
      />
      <ConfirmModal
        open={openSubmit}
        handleCancel={handleCloseSubmit}
        handleSubmit={handleSubmit}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="info"
        btnTitle="Submit"
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default DataSchemeTable;
